import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconBoltDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M13.191 2.52a.78.78 0 0 1 .627.75v6.615h5.04c.282 0 .544.138.692.364.148.227.161.51.035.749l-5.853 11.077a.83.83 0 0 1-.914.404.78.78 0 0 1-.626-.748v-6.616H7.15a.82.82 0 0 1-.692-.364.73.73 0 0 1-.035-.749l5.853-11.077a.83.83 0 0 1 .914-.404" clipRule="evenodd" /></svg></>;
}
export default IconBoltDefault;